// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeEdu = {
  eduPlatformApplicationNotFound: "EDU platform application {app_key} was not found",
  eduPlatformDataContractInvalid:
    "The EDU platform data contract is invalid for {field_name}: {reason}",
} as const;
